import React from 'react'
import { Col, Row } from 'react-bootstrap'
import classNames from 'classnames'
import Image from './image'

/**
 * Renders an image and children beside.
 *
 * @param imageSrc The src of the image. Should be an JSX Element
 * @param {string} imageAlt Alt of the image
 * @param {JSX.Element} children The text beside the image.
 * @param {boolean} imageRight Whether the image should be to the right of the text
 * @param {'triangle' | 'circles' | 'square'} imageDeco What image deco should be used
 * @param {'small-img'} variant Style variants
 */
const ImageWithText = ({ imageSrc, imageAlt, children, imageRight, imageDeco, variant }) => {
  const containerClasses = classNames({
    'image-with-text__container': true,
    right: imageRight,
    'image-with-text__container--small-img': variant === 'small-img',
  })

  const imageClasses = classNames({
    'img-deco-triangle': imageDeco === 'triangle',
    'img-deco-circles': imageDeco === 'circles',
    'img-deco-square': imageDeco === 'square',
  })

  if (imageRight)
    return (
      <Row className={containerClasses}>
        <Col xs={12} md={variant === 'small-img' ? 9 : 6} className="image-with-text__text-container">
          {children}
        </Col>

        <Col xs={12} md={variant === 'small-img' ? 3 : 6} className="align-items-center">
          <div className="img-deco-container">
            <Image filename={imageSrc} alt={imageAlt} className={imageClasses} />
            <span className="img-deco" />
          </div>
        </Col>
      </Row>
    )

  return (
    <Row className={containerClasses}>
      <Col xs={12} md={variant === 'small-img' ? 3 : 6} className="align-items-center">
        <div className="img-deco-container">
          <Image filename={imageSrc} alt={imageAlt} className={imageClasses} />
          <span className="img-deco" />
        </div>
      </Col>

      <Col xs={12} md={variant === 'small-img' ? 9 : 6} className="image-with-text__text-container">
        {children}
      </Col>
    </Row>
  )
}

export default ImageWithText
